import { useState, useEffect } from 'react';
const useLoadCompanyImage = (url, size, notShowDefaultImage) => {
  const cdnUrl = `${import.meta.env.VITE_APP_CDNURL}/images/20230909-company-placeholder.png`;
  const [imageState, setImageState] = useState({
    loading: true,
    src: cdnUrl,
  });
  useEffect(() => {
    if (url) {
      const img = new Image();
      const urlObject = new URL(url);
      const searchParams = new URLSearchParams(urlObject.search);
      if (size) {
        searchParams.set('size', size);
      }
      const finalSrc = `${urlObject.origin}${urlObject.pathname}?${searchParams?.toString()}`;
      img.onload = () => {
        setImageState({ loading: false, src: finalSrc });
      };
      img.onerror = () => {
        setImageState({ loading: false, src: cdnUrl, defaultImage: true });
      };
      img.src = finalSrc;
    } else {
      setImageState({ loading: false, src: cdnUrl, defaultImage: true });
    }
  }, [url, size, cdnUrl]);
  return imageState;
};

export default useLoadCompanyImage;
